import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from 'react-bootstrap';

const TestSubscriptionPlans = () => {
  const navigate = useNavigate();

  const handleTestNavigation = () => {
    // Navigate to the subscription plans page with sample registration data
    navigate('/registration-subscription', {
      state: {
        registrationData: {
          email: 'test@example.com',
          corporateName: 'Test Company',
          userName: 'John Doe',
          phoneNumber: '+1234567890',
          countryId: '1'
        }
      }
    });
  };

  return (
    <div className="container py-5">
      <div className="row justify-content-center">
        <div className="col-md-8 text-center">
          <h1 className="mb-4">Test Subscription Plans Page</h1>
          <p className="lead mb-4">
            This page allows you to test the new registration subscription plans page.
            Click the button below to navigate to the subscription plans page with sample data.
          </p>
          <Button 
            variant="primary" 
            size="lg" 
            onClick={handleTestNavigation}
            className="me-3"
          >
            <i className="fas fa-crown me-2"></i>
            Test Subscription Plans
          </Button>
          <Button 
            variant="outline-secondary" 
            size="lg" 
            onClick={() => navigate('/pricing')}
          >
            <i className="fas fa-arrow-left me-2"></i>
            Back to Pricing
          </Button>
        </div>
      </div>
    </div>
  );
};

export default TestSubscriptionPlans;
